import axiosInstance from '../axiosInterceptor/axiosInstance'

const getGenderSpec = async () => {
  const url = '/teams/genders'
  const response = await axiosInstance.get(url)
  return response?.data
}

export default getGenderSpec
